import {
	includedPropList,
	includedT2PropList,
} from "../../../pages/activityBuilder/modules/grasslandManagement/grasslandManagement";
import type {
	ModuleFull,
	GrasslandResponse,
} from "../../../pages/activityBuilder/modules/grasslandManagement/grasslandTypes";
import { apiSlice, publicApiSlice, TagTypes } from "../../apiSlice";
import { createModuleGetApi, createModuleUpdateApi } from "./factories/createModuleApi";
import { transformModuleResponse, prepareModulePayload } from "./factories/moduleApiUtils";
import { FEModules, FEModulesObj } from "../../../utils/moduleList";

// Define constants for the module
const MODULE_TYPE = "Grasslands";
const TAG: TagTypes = "Grassland";
const TAG_DEFAULTS: TagTypes = "GrasslandDefaults";
const ENDPOINT = FEModulesObj[FEModules.Grassland].path;

const t1PercentageProps = ["fire_impact"];
const t2PercentageProps = ["combustion_factor_t2"];

const transformResponse = (response: GrasslandResponse) => transformModuleResponse<GrasslandResponse, ModuleFull>({
	response,
	includedPropList,
	includedT2PropList,
	percentageProps: t1PercentageProps,
	t2PercentageProps
})

const grasslandApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const publicGrasslandApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice: publicApiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const transformUpdatePayload = (data: ModuleFull, activityId: number) => prepareModulePayload({
	moduleData: data.module,
	tiertwoData: data.tiertwo,
	percentageProps: t1PercentageProps,
	t2PercentageProps,
	activityId
})
const mutationApiSlice = createModuleUpdateApi<ModuleFull, GrasslandResponse>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformUpdatePayload,
	includesLandUseChange: true,
})

export const {
	useUpdateGrasslandsMutation,
} = mutationApiSlice;

export const {
	useGetGrasslandsQuery: usePublicGetGrasslandsQuery,
	useGetGrasslandsDefaultsQuery: usePublicGetGrasslandsDefaultsQuery,
} = publicGrasslandApiSlice;

export const {
	useGetGrasslandsQuery,
	useGetGrasslandsDefaultsQuery
} = grasslandApiSlice;